export function scrollToId(id: string) {
  const element = document.getElementById(id);

  if (!element) {
    return;
  }

  element.scrollIntoView({ behavior: 'smooth' });

  element.classList.add('!ring-2');

  setTimeout(function () {
    element.classList.remove('!ring-2');
  }, 1_000);
}
